export default {
	data() {
		return {
			booking_status_filter: "",
			booking_types_filter: "",
			booking_source_filter: "",
			booking_guest_number_filter: "",
			booking_guest_type_filter: [],
			booking_accommodation_filter: [],
			booking_activity_filter: [],
			booking_partner_type_filter: "",
			booking_partners_filter: "",
			booking_membershiplevel_filter: "",
			payment_status_filter: ""
		};
	},
	methods: {
		$openPayment: function () {
			this.$router.push({
				name: "GatePayment",
				params: {
					booking_id: this.$route.params.booking_id
				}
			});
		},
		adjustDates: function (checkIn, checkOut) {
			var userData = JSON.parse(localStorage.getItem("user_data"));
			userData.check_in = checkIn;
			userData.check_out = checkOut;
			localStorage.setItem("user_data", JSON.stringify(userData));
		},
		$findBookingStatus() {
			var status = ["No Filter"];
			if (this.$route.name == 'BookingsReport') {
				this.allBookingsReport.map(function (booking) {
					status.push(booking.booking_status);
				});
			} else {
				this.allBookings.map(function (booking) {
					status.push(booking.booking_status);
				});
			}

			return status;
		},
		$findBookingTypes() {

			var status = ["No Filter"];
			if (this.$route.name == 'BookingsReport') {
				this.allBookingsReport.map(function (booking) {
					status.push(booking.booking_type);
				});

			} else {
				this.allBookings.map(function (booking) {
					status.push(booking.booking_type);
				});

			}

			return status;
		},
		$partnerTypes() {
			var status = ["No Filter"];
			if (this.$route.name == 'BookingsReport') {
				this.allBookingsReport.map(function (booking) {
					if (booking.partner_type !== null) {
						status.push(booking.partner_type);
					}
				});
			} else {
				this.allBookings.map(function (booking) {
					if (booking.partner_type !== null) {
						status.push(booking.partner_type);
					}
				});

			}

			return status;
		},
		$partnerBookings() {
			var status = ["No Filter"];
			if (this.$route.name == 'BookingsReport') {
				this.allBookingsReport.map(function (booking) {
					if (booking.partner_name !== null) {
						status.push(booking.partner_name);
					}
				});
			} else {
				this.allBookings.map(function (booking) {
					if (booking.partner_name !== null) {
						status.push(booking.partner_name);
					}
				});
			}
			return status;
		},
		$findPaymentStatus() {
		var status = ["No Filter"];
		if (this.$route.name == 'BookingsReport') {
			this.allBookingsReport.map(function (booking) {
				status.push(booking.booking_payment_status);
			});
		} else {
			this.allBookings.map(function (booking) {
				if (booking.booking_payment_status !== null) {
					status.push(booking.booking_payment_status);
				}
			});
		}
		return status;
},
		$memberBookings() {
			var status = ["No Filter"];
			if (this.$route.name == 'BookingsReport') {
				this.allBookingsReport.map(function (booking) {
					if (booking.membership_level !== null) {
						status.push(booking.membership_level);
					}
				});
			} else {
				this.allBookings.map(function (booking) {
					if (booking.membership_level !== null) {
						status.push(booking.membership_level);
					}
				});
			}
			return status;
		},
		$dev() {
			var status = ["No Filter"];
			if (this.$route.name == 'BookingsReport') {
				this.allBookingsReport.map(function (booking) {
					status.push(booking.booking_payment_status);
				});
			} else {
				this.allBookings.map(function (booking) {
					if (booking.booking_payment_status !== null) {
						status.push(booking.booking_payment_status);
					}
				});
			}
			return status;
		},
		$findBookingSource() {
			var status = ["No Filter"];
			if (this.$route.name == 'BookingsReport') {
				this.allBookingsReport.map(function (booking) {
					status.push(booking.session_user);
				});
			} else {
				this.allBookings.map(function (booking) {
					status.push(booking.session_user);
				});

			}

			return status;
		},
		$findPartnerBookingSource() {
			var status = ["No Filter"];
			this.partnerBookings.map(function (booking) {
				status.push(booking.session_user);
			});
			return status;
		},
		$findPartnerBookingStatus() {
			var status = ["No Filter"];
			this.partnerBookings.map(function (booking) {
				status.push(booking.booking_status);
			});
			return status;
		},
		$findGuestNumbers() {
			var status = [
				"No Filter",
				"1",
				"2",
				"<= 3",
				"<= 5",
				"<= 10",
				"<= 25",
				"<= 50"
			];
			return status;
		}
	},
	computed: {
		$bookingPaidStatus() {
			if (this.singleBooking.booking_payment_balance > 0) {
				return false;
			} else {
				return true;
			}
		},

		updateGateEntry: function () {
	if (
		this.$route.name === "EditBooking" ||
		this.$route.name === "PostponeBooking"
	) {
		const booking = this.singleBooking;
		const details = booking.booking_details || {};
		
		
		this.gate_pass.check_in = this.$moment(
			booking.booking_check_in_date
		).format("YYYY-MM-DD");
		this.gate_pass.check_out = this.$moment(
			booking.booking_check_out_date
		).format("YYYY-MM-DD");
		this.gate_pass.currency = booking.currency;
		this.gate_pass.first_name = details.first_name || '';
		this.gate_pass.last_name = details.last_name || '';
		this.gate_pass.email = details.email_address || '';
		this.gate_pass.phone = details.phone_number || '';
		this.gate_pass.destination = booking.destination_id || '';
		this.gate_pass.destination_name = booking.destination || '';
		
		
		this.gate_pass.code = details.country_code || details.code || '';
		this.gate_pass.country_details = details.country_details || {};
		
		
		this.gate_pass.entry_mode = details.entry_mode_public_id || 
		                           details.entry_mode || 
		                           booking.entry_mode || 
		                           '';
		
		this.gate_pass.entry_point = details.gate_public_id || 
		                            details.entry_point || 
		                            booking.entry_point || 
		                            '';
		
		this.gate_pass.mode_registration = details.mode_registration || 
		                                  booking.mode_registration || 
		                                  '';
		
		this.gate_pass.promo_code = booking.promo_code || 
		                           details.promo_code || 
		                           '';
		
		this.gate_pass.kra_pin_number = details.kra_pin_number || '';
		this.gate_pass.note = details.additional_note || details.note || '';
		
		
		var vehicleData = { data: booking.vehicles };
		this.$store.commit("GET_ALL_VEHICLE_FEES", vehicleData);
	}
},
		updatePartnerBooking: function () {
			if (
				this.$route.name === "EditBooking" ||
				this.$route.name === "PostponeBooking"
			) {
				this.gate_pass.partner_id = this.singleBooking.partner_id;
				this.gate_pass.check_in = this.$moment(
					this.singleBooking.booking_check_in_date
				).format("YYYY-MM-DD");
				this.gate_pass.check_out = this.$moment(
					this.singleBooking.booking_check_out_date
				).format("YYYY-MM-DD");
				this.gate_pass.currency = this.singleBooking.currency;
				this.gate_pass.first_name = this.singleBooking.booking_details.first_name;
				this.gate_pass.last_name = this.singleBooking.booking_details.last_name;
				this.gate_pass.email = this.singleBooking.booking_details.email_address;
				this.gate_pass.phone = this.singleBooking.booking_details.phone_number;
				this.gate_pass.destination = this.singleBooking.destination_id;
				this.gate_pass.destination_name = this.singleBooking.destination;
				this.gate_pass.partner_booking_ref = this.singleBooking.partner_booking_ref;
				var vehicleData = { data: this.singleBooking.vehicles };
				this.$store.commit("GET_ALL_VEHICLE_FEES", vehicleData);
			}
		},
		updateMemberBooking: function () {
			if (
				this.$route.name === "EditBooking" ||
				this.$route.name === "PostponeBooking"
			) {
				this.gate_pass.check_in = this.$moment(
					this.singleBooking.booking_check_in_date
				).format("YYYY-MM-DD");
				this.gate_pass.check_out = this.$moment(
					this.singleBooking.booking_check_out_date
				).format("YYYY-MM-DD");
				this.gate_pass.currency = this.singleBooking.currency;
				this.gate_pass.organisation_type = this.singleBooking.booking_type_id;
				this.gate_pass.email = this.singleBooking.booking_details.email_address;
				this.gate_pass.phone = this.singleBooking.booking_details.phone_number;
				this.gate_pass.destination = this.singleBooking.destination_id;
				this.gate_pass.destination_name = this.singleBooking.destination;
				this.gate_pass.member = this.singleBooking.member_details;
				this.gate_pass.member.memberID = this.singleBooking.member_details.member_id;
				var vehicleData = { data: this.singleBooking.vehicles };
				this.$store.commit("GET_ALL_VEHICLE_FEES", vehicleData);
			}
		},
		updateGroupBooking: function () {
			if (
				this.$route.name === "EditBooking" ||
				this.$route.name === "PostponeBooking"
			) {
				this.gate_pass.check_in = this.$moment(
					this.singleBooking.booking_check_in_date
				).format("YYYY-MM-DD");
				this.gate_pass.check_out = this.$moment(
					this.singleBooking.booking_check_out_date
				).format("YYYY-MM-DD");
				this.gate_pass.currency = this.singleBooking.currency;
				this.gate_pass.organisation_type = this.singleBooking.booking_type_id;
				this.gate_pass.email = this.singleBooking.booking_details.email_address;
				this.gate_pass.phone = this.singleBooking.booking_details.phone_number;
				this.gate_pass.destination = this.singleBooking.destination_id;
				this.gate_pass.school.destination = this.singleBooking.destination_id;
				this.gate_pass.school.destination_name = this.singleBooking.destination;
				if (this.singleBooking.booking_type_id === "8D7E6504") {
					this.gate_pass.school.primary_contact = this.singleBooking.school_booking_details[0].primary_contact;
					this.gate_pass.school.primary_contact_email = this.singleBooking.school_booking_details[0].primary_contact_email;
					this.gate_pass.school.primary_contact_phone = this.singleBooking.school_booking_details[0].primary_contact_phone;
					this.gate_pass.school.secondary_contact = this.singleBooking.school_booking_details[0].secondary_contact;
					this.gate_pass.school.secondary_contact_email = this.singleBooking.school_booking_details[0].secondary_contact_email;
					this.gate_pass.school.secondary_contact_phone = this.singleBooking.school_booking_details[0].secondary_contact_phone;
					this.gate_pass.school.school_id = this.singleBooking.school_booking_details[0].school_public_id;
				} else if (this.singleBooking.booking_type_id === "C3237489") {
					// Organizations
					this.gate_pass.organisation_name = this.singleBooking.corporate_booking_details[0].organisation_name;
					this.gate_pass.organisation_email = this.singleBooking.corporate_booking_details[0].organisation_email;
					this.gate_pass.name = this.singleBooking.booking_details.first_name;
				}
				var vehicleData = { data: this.singleBooking.vehicles };
				this.$store.commit("GET_ALL_VEHICLE_FEES", vehicleData);
			}
		},
		getCheckinCheckout: function () {
			var userData = JSON.parse(localStorage.getItem("user_data"));
			// this.$store.state.ConservationFeeStore.all_conservation_fees = JSON.parse(localStorage.getItem('conservation_data'))
			this.booking.check_in = userData.check_in;
			this.booking.check_out = userData.check_out;
		},
		pendingPartnerBookings: function () {
			return this.$store.state.BookingStore.pending_partner_bookings;
		},
		pendingGroupBookings: function () {
			return this.$store.state.BookingStore.pending_group_bookings;
		},
		allBookings: function () {
			return this.$store.state.BookingStore.all_bookings;
		},
		allBookingsReport: function () {
			return this.$store.state.BookingStore.all_bookings_report;
		},
		// allBookingsTotal: function () {
		// 	var allBookings = this.allBookings;

		// 	var total = 0;
		// 	if (allBookings.length == 0) {
		// 		return total;
		// 	} else {

		// 		for (var i = 0; i < allBookings.length; i++) {

		// 			let booking_currency = allBookings[i].booking_currency;
		// 			let booking_total = allBookings[i].booking_total;
		// 			let booking_status = allBookings[i].status;
		// 			let converted_amount = 0
		// 			if (booking_status == 'Cancelled') {
		// 				converted_amount = 0
		// 			} else {
		// 				converted_amount = this.convert2(booking_currency, this.currency, booking_total).amount;
		// 			}
		// 			total += converted_amount
		// 		}

		// 		return total;
		// 	}

		// },

		addToAllBookings: function (bookings) {
			return this.$store.state.BookingStore.all_bookings.push(bookings);
		},
		$filterBooking() {
			var allBookings = this.allBookings;
			if (
				this.booking_status_filter.length > 0 &&
				this.booking_status_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking => booking.booking_status === this.booking_status_filter
				);
			}
			if (
				this.payment_status_filter.length > 0 &&
				this.payment_status_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking =>
						booking.booking_payment_status === this.payment_status_filter
				);
			}
			if (
				this.booking_types_filter.length > 0 &&
				this.booking_types_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking => booking.booking_type === this.booking_types_filter
				);
			}
			if (
				this.booking_source_filter.length > 0 &&
				this.booking_source_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking => booking.session_user === this.booking_source_filter
				);
			}
			if (
				this.booking_partner_type_filter.length > 0 &&
				this.booking_partner_type_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking => booking.partner_type === this.booking_partner_type_filter
				);
			}
			if (
				this.booking_partners_filter.length > 0 &&
				this.booking_partners_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking => booking.partner_name === this.booking_partners_filter
				);
			}
			if (
				this.booking_membershiplevel_filter.length > 0 &&
				this.booking_membershiplevel_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking =>
						booking.membership_level === this.booking_membershiplevel_filter
				);
			}
			if (
				this.booking_guest_number_filter.length > 0 &&
				this.booking_guest_number_filter !== "No Filter"
			) {
				if (this.booking_guest_number_filter === "1") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) === 1;
					});
				}
				if (this.booking_guest_number_filter === "2") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) === 2;
					});
				}
				if (this.booking_guest_number_filter === "<= 3") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) <= 3;
					});
				}
				if (this.booking_guest_number_filter === "<= 5") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) <= 5;
					});
				}
				if (this.booking_guest_number_filter === "<= 10") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) <= 10;
					});
				}
				if (this.booking_guest_number_filter === "<= 25") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) <= 25;
					});
				}
				if (this.booking_guest_number_filter === "<= 50") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) <= 50;
					});
				}
			}
			if (this.booking_guest_type_filter.length > 0) {
				var bookings = [];
				this.booking_guest_type_filter.map(function (filter) {
					allBookings.map(function (booking) {
						booking.guests.find(function (guest) {
							if (guest.guest_type === filter && guest.no_of_guests > 0) {
								bookings.push(booking);
							}
						});
					});
				});
				return bookings;
				// allBookings = allBookings.filter(booking => booking.booking_type === this.booking_types_filter)
			}
			if (this.booking_accommodation_filter.length > 0) {
				var bookings = [];
				this.booking_accommodation_filter.map(function (filter) {
					allBookings.map(function (booking) {
						booking.facility_bookings.find(function (accommodation) {
							if (accommodation.facility_id === filter) {
								bookings.push(booking);
							}
						});
					});
				});
				return bookings;
				// allBookings = allBookings.filter(booking => booking.booking_type === this.booking_types_filter)
			}
			if (this.booking_activity_filter.length > 0) {
				var bookings = [];
				this.booking_activity_filter.map(function (filter) {
					allBookings.map(function (booking) {
						booking.inventory_bookings.find(function (activity) {
							if (activity.inventory_id === filter) {
								bookings.push(booking);
							}
						});
					});
				});
				return bookings;
				// allBookings = allBookings.filter(booking => booking.booking_type === this.booking_types_filter)
			}
			return allBookings;
		},$filterBooking() {
    var allBookings = this.allBookings;
    
    // Status filter
    if (
        this.booking_status_filter.length > 0 &&
        this.booking_status_filter !== "No Filter"
    ) {
        allBookings = allBookings.filter(
            booking => booking.booking_status === this.booking_status_filter
        );
    }
    
    // Payment status filter
    if (
        this.payment_status_filter.length > 0 &&
        this.payment_status_filter !== "No Filter"
    ) {
        allBookings = allBookings.filter(
            booking =>
                booking.booking_payment_status === this.payment_status_filter
        );
    }
    
    // Booking type filter
    if (
        this.booking_types_filter.length > 0 &&
        this.booking_types_filter !== "No Filter"
    ) {
        allBookings = allBookings.filter(
            booking => booking.booking_type === this.booking_types_filter
        );
    }
    
    // Booking source filter
    if (
        this.booking_source_filter.length > 0 &&
        this.booking_source_filter !== "No Filter"
    ) {
        allBookings = allBookings.filter(
            booking => booking.session_user === this.booking_source_filter
        );
    }
    
    // Partner type filter
    if (
        this.booking_partner_type_filter.length > 0 &&
        this.booking_partner_type_filter !== "No Filter"
    ) {
        allBookings = allBookings.filter(
            booking => booking.partner_type === this.booking_partner_type_filter
        );
    }
    
    // Partners filter
    if (
        this.booking_partners_filter.length > 0 &&
        this.booking_partners_filter !== "No Filter"
    ) {
        allBookings = allBookings.filter(
            booking => booking.partner_name === this.booking_partners_filter
        );
    }
    
    // Membership level filter
    if (
        this.booking_membershiplevel_filter.length > 0 &&
        this.booking_membershiplevel_filter !== "No Filter"
    ) {
        allBookings = allBookings.filter(
            booking =>
                booking.membership_level === this.booking_membershiplevel_filter
        );
    }
    
    // DESTINATION FILTER - ADDED
    if (
        this.destination_filter &&
        this.destination_filter !== "No Filter"
    ) {
        allBookings = allBookings.filter(
            booking => booking.destination && 
                      booking.destination === this.destination_filter
        );
    }
    
    // COUNTRY FILTER - ADDED
    if (
        this.country_filter &&
        this.country_filter !== "No Filter"
    ) {
        allBookings = allBookings.filter(
            booking => booking.country && 
                      booking.country === this.country_filter
        );
    }
    
    // Guest number filter
    if (
        this.booking_guest_number_filter.length > 0 &&
        this.booking_guest_number_filter !== "No Filter"
    ) {
        if (this.booking_guest_number_filter === "1") {
            allBookings = allBookings.filter(function (booking) {
                return Number(booking.guest_total) === 1;
            });
        }
        if (this.booking_guest_number_filter === "2") {
            allBookings = allBookings.filter(function (booking) {
                return Number(booking.guest_total) === 2;
            });
        }
        if (this.booking_guest_number_filter === "<= 3") {
            allBookings = allBookings.filter(function (booking) {
                return Number(booking.guest_total) <= 3;
            });
        }
        if (this.booking_guest_number_filter === "<= 5") {
            allBookings = allBookings.filter(function (booking) {
                return Number(booking.guest_total) <= 5;
            });
        }
        if (this.booking_guest_number_filter === "<= 10") {
            allBookings = allBookings.filter(function (booking) {
                return Number(booking.guest_total) <= 10;
            });
        }
        if (this.booking_guest_number_filter === "<= 25") {
            allBookings = allBookings.filter(function (booking) {
                return Number(booking.guest_total) <= 25;
            });
        }
        if (this.booking_guest_number_filter === "<= 50") {
            allBookings = allBookings.filter(function (booking) {
                return Number(booking.guest_total) <= 50;
            });
        }
    }
    
    // Guest type filter (returns early)
    if (this.booking_guest_type_filter.length > 0) {
        var bookings = [];
        this.booking_guest_type_filter.map(function (filter) {
            allBookings.map(function (booking) {
                booking.guests.find(function (guest) {
                    if (guest.guest_type === filter && guest.no_of_guests > 0) {
                        bookings.push(booking);
                    }
                });
            });
        });
        return bookings;
    }
    
    // Accommodation filter (returns early)
    if (this.booking_accommodation_filter.length > 0) {
        var bookings = [];
        this.booking_accommodation_filter.map(function (filter) {
            allBookings.map(function (booking) {
                booking.facility_bookings.find(function (accommodation) {
                    if (accommodation.facility_id === filter) {
                        bookings.push(booking);
                    }
                });
            });
        });
        return bookings;
    }
    
    // Activity filter (returns early)
    if (this.booking_activity_filter.length > 0) {
        var bookings = [];
        this.booking_activity_filter.map(function (filter) {
            allBookings.map(function (booking) {
                booking.inventory_bookings.find(function (activity) {
                    if (activity.inventory_id === filter) {
                        bookings.push(booking);
                    }
                });
            });
        });
        return bookings;
    }
    
    return allBookings;
},
		$filterBookingsReport() {
			var allBookingsReport = this.allBookingsReport;
			if (
				this.booking_status_filter.length > 0 &&
				this.booking_status_filter !== "No Filter"
			) {
				allBookingsReport = allBookingsReport.filter(
					booking => booking.booking_status === this.booking_status_filter
				);
			}
			if (
				this.payment_status_filter.length > 0 &&
				this.payment_status_filter !== "No Filter"
			) {
				allBookingsReport = allBookingsReport.filter(
					booking =>
						booking.booking_payment_status === this.payment_status_filter
				);
			}
			if (
				this.booking_types_filter.length > 0 &&
				this.booking_types_filter !== "No Filter"
			) {
				allBookingsReport = allBookingsReport.filter(
					booking => booking.booking_type === this.booking_types_filter
				);
			}
			if (
				this.booking_source_filter.length > 0 &&
				this.booking_source_filter !== "No Filter"
			) {
				allBookingsReport = allBookingsReport.filter(
					booking => booking.session_user === this.booking_source_filter
				);
			}
			if (
				this.booking_partner_type_filter.length > 0 &&
				this.booking_partner_type_filter !== "No Filter"
			) {
				allBookingsReport = allBookingsReport.filter(
					booking => booking.partner_type === this.booking_partner_type_filter
				);
			}
			if (
				this.booking_partners_filter.length > 0 &&
				this.booking_partners_filter !== "No Filter"
			) {
				allBookingsReport = allBookingsReport.filter(
					booking => booking.partner_name === this.booking_partners_filter
				);
			}
			if (
				this.booking_membershiplevel_filter.length > 0 &&
				this.booking_membershiplevel_filter !== "No Filter"
			) {
				allBookingsReport = allBookingsReport.filter(
					booking =>
						booking.membership_level === this.booking_membershiplevel_filter
				);
			}
			if (
				this.booking_guest_number_filter.length > 0 &&
				this.booking_guest_number_filter !== "No Filter"
			) {
				if (this.booking_guest_number_filter === "1") {
					allBookingsReport = allBookingsReport.filter(function (booking) {
						return Number(booking.guest_total) === 1;
					});
				}
				if (this.booking_guest_number_filter === "2") {
					allBookingsReport = allBookingsReport.filter(function (booking) {
						return Number(booking.guest_total) === 2;
					});
				}
				if (this.booking_guest_number_filter === "<= 3") {
					allBookingsReport = allBookingsReport.filter(function (booking) {
						return Number(booking.guest_total) <= 3;
					});
				}
				if (this.booking_guest_number_filter === "<= 5") {
					allBookingsReport = allBookingsReport.filter(function (booking) {
						return Number(booking.guest_total) <= 5;
					});
				}
				if (this.booking_guest_number_filter === "<= 10") {
					allBookingsReport = allBookingsReport.filter(function (booking) {
						return Number(booking.guest_total) <= 10;
					});
				}
				if (this.booking_guest_number_filter === "<= 25") {
					allBookingsReport = allBookingsReport.filter(function (booking) {
						return Number(booking.guest_total) <= 25;
					});
				}
				if (this.booking_guest_number_filter === "<= 50") {
					allBookingsReport = allBookingsReport.filter(function (booking) {
						return Number(booking.guest_total) <= 50;
					});
				}
			}
			if (this.booking_guest_type_filter.length > 0) {
				var bookings = [];
				this.booking_guest_type_filter.map(function (filter) {
					allBookingsReport.map(function (booking) {
						booking.guests.find(function (guest) {
							if (guest.guest_type === filter && guest.no_of_guests > 0) {
								bookings.push(booking);
							}
						});
					});
				});
				return bookings;
				// allBookingsReport = allBookingsReport.filter(booking => booking.booking_type === this.booking_types_filter)
			}
			if (this.booking_accommodation_filter.length > 0) {
				var bookings = [];
				this.booking_accommodation_filter.map(function (filter) {
					allBookingsReport.map(function (booking) {
						booking.facility_bookings.find(function (accommodation) {
							if (accommodation.facility_id === filter) {
								bookings.push(booking);
							}
						});
					});
				});
				return bookings;
				// allBookingsReport = allBookingsReport.filter(booking => booking.booking_type === this.booking_types_filter)
			}
			if (this.booking_activity_filter.length > 0) {
				var bookings = [];
				this.booking_activity_filter.map(function (filter) {
					allBookingsReport.map(function (booking) {
						booking.inventory_bookings.find(function (activity) {
							if (activity.inventory_id === filter) {
								bookings.push(booking);
							}
						});
					});
				});
				return bookings;
				// allBookingsReport = allBookingsReport.filter(booking => booking.booking_type === this.booking_types_filter)
			}
			return allBookingsReport;
		},
		$filterPartnerBooking() {
			var allBookings = this.partnerBookings;
			if (
				this.booking_status_filter.length > 0 &&
				this.booking_status_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking => booking.booking_status === this.booking_status_filter
				);
			}
			if (
				this.booking_types_filter.length > 0 &&
				this.booking_types_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking => booking.booking_type === this.booking_types_filter
				);
			}
			if (
				this.booking_source_filter.length > 0 &&
				this.booking_source_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking => booking.session_user === this.booking_source_filter
				);
			}
			if (
				this.booking_partner_type_filter.length > 0 &&
				this.booking_partner_type_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking => booking.partner_type === this.booking_partner_type_filter
				);
			}
			if (
				this.booking_partners_filter.length > 0 &&
				this.booking_partners_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking => booking.partner_name === this.booking_partners_filter
				);
			}
			if (
				this.booking_membershiplevel_filter.length > 0 &&
				this.booking_membershiplevel_filter !== "No Filter"
			) {
				allBookings = allBookings.filter(
					booking =>
						booking.membership_level === this.booking_membershiplevel_filter
				);
			}
			if (
				this.booking_guest_number_filter.length > 0 &&
				this.booking_guest_number_filter !== "No Filter"
			) {
				if (this.booking_guest_number_filter === "1") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) === 1;
					});
				}
				if (this.booking_guest_number_filter === "2") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) === 2;
					});
				}
				if (this.booking_guest_number_filter === "<= 3") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) <= 3;
					});
				}
				if (this.booking_guest_number_filter === "<= 5") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) <= 5;
					});
				}
				if (this.booking_guest_number_filter === "<= 10") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) <= 10;
					});
				}
				if (this.booking_guest_number_filter === "<= 25") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) <= 25;
					});
				}
				if (this.booking_guest_number_filter === "<= 50") {
					allBookings = allBookings.filter(function (booking) {
						return Number(booking.guest_total) <= 50;
					});
				}
			}
			if (this.booking_guest_type_filter.length > 0) {
				var bookings = [];
				this.booking_guest_type_filter.map(function (filter) {
					allBookings.map(function (booking) {
						booking.guests.find(function (guest) {
							if (guest.guest_type === filter && guest.no_of_guests > 0) {
								bookings.push(booking);
							}
						});
					});
				});
				return bookings;
				// allBookings = allBookings.filter(booking => booking.booking_type === this.booking_types_filter)
			}
			if (this.booking_accommodation_filter.length > 0) {
				var bookings = [];
				this.booking_accommodation_filter.map(function (filter) {
					allBookings.map(function (booking) {
						booking.facility_bookings.find(function (accommodation) {
							if (accommodation.facility_id === filter) {
								bookings.push(booking);
							}
						});
					});
				});
				return bookings;
				// allBookings = allBookings.filter(booking => booking.booking_type === this.booking_types_filter)
			}
			if (this.booking_activity_filter.length > 0) {
				var bookings = [];
				this.booking_activity_filter.map(function (filter) {
					allBookings.map(function (booking) {
						booking.inventory_bookings.find(function (activity) {
							if (activity.inventory_id === filter) {
								bookings.push(booking);
							}
						});
					});
				});
				return bookings;
				// allBookings = allBookings.filter(booking => booking.booking_type === this.booking_types_filter)
			}
			return allBookings;
		},
		organizationTypes: function () {
			return this.$store.state.GroupBookingTypeStore.all_group_booking_types;
		},
		singleBooking: function () {
			return this.$store.state.BookingStore.booking;
		},
		singleBookingDetail: function () {
			return this.$store.state.BookingStore.booking_detail;
		},
		singleBookingMoreDetail: function () {
			return this.$store.state.BookingStore.booking_more_detail;
		},
		$singleBookingGetDetail: function () {
			this.$store.state.BookingStore.booking_more_detail;
		},
		singleBookingCheckIn: function () {
			return this.$store.state.BookingStore.booking_checkin;
		},
		singleBookingCost: function () {
			return this.$store.state.BookingStore.booking_cost;
		},

		singleInspectionBooking: function () {
			return this.$store.state.BookingStore.inspection_booking;
		},
		successBooking: function () {
			return this.$store.state.BookingStore.success_booking;
		},
		vehiclePrices: function () {
			return this.$store.BookingStore.vehicle_entry;
		},
		inventoryAvailability: function () {
			return this.$store.state.InventoryStore.inventory_num;
		},
		browserBooking: function () {
			return this.$store.state.BookingStore.local_booking;
		},
		inventoryBudget: function () {
			return this.$store.state.InventoryStore.inventory_selection;
		},
		getCheckInToday: function () {
			return this.$store.state.BookingStore.checking_in_today;
		},
		getInspectionToday: function () {
			return this.$store.state.BookingStore.inspection_bookings;
		},

		getInspectedAlerted: function () {
			return this.$store.state.BookingStore.inspection_alerted_bookings;
		},
		getAllBookingProofs: function () {
			return this.$store.state.BookingStore.all_residency_proof;
		},
		getInspectedUnticketedAlerted: function () {
			return this.$store.state.BookingStore.inspection_unticketed_alerted_bookings;
		},
		getBookingsBan: function () {
			return this.$store.state.BookingStore.all_bookings_ban;
		},
		getBookingsBanCSV: function () {

			let bookings_ban = this.$store.state.BookingStore.all_bookings_ban;
			let bookings_ban_arr = [];
			if (bookings_ban == undefined) {
				return [];
			} else {
				for (let i = 0; i < bookings_ban.length; i++) {
					let bookings_ban_obj = {};
					bookings_ban_obj["first_name"] = bookings_ban[i].first_name;
					bookings_ban_obj["last_name"] = bookings_ban[i].last_name;
					bookings_ban_obj["email_address"] = bookings_ban[i].email_address;
					bookings_ban_obj["phone_number"] = bookings_ban[i].phone_number;
					bookings_ban_obj["vehicle_registration"] = bookings_ban[i].vehicle_registration;
					bookings_ban_obj["booking_ban_start_date"] = this.formated_date(bookings_ban[i].booking_ban_start_date);
					bookings_ban_obj["booking_ban_end_date"] = this.formated_date(bookings_ban[i].booking_ban_end_date);
					bookings_ban_obj["status"] = bookings_ban[i].status;
					bookings_ban_obj["session_user"] = bookings_ban[i].session_user;
					bookings_ban_obj["created_at"] = this.formated_date(bookings_ban[i].created_at);

					bookings_ban_arr.push(bookings_ban_obj);
				}
				return bookings_ban_arr;
			}
		},
		getBookingBan: function () {
			return this.$store.state.BookingStore.booking_ban;
		},
		getCheckOutToday: function () {
			return this.$store.state.BookingStore.checking_out_today;
    },
    getOverstaysThisMonth: function () {
      return this.$store.state.BookingStore.overstays_this_month;
    },
		getInventoryCalendar: function () {
			return this.$store.state.CalendarStore.calendar_inventory;
		},
		getCampingCalendar: function () {
			return this.$store.state.CalendarStore.calendar_camping;
		},
		getAccomodationCalendar: function () {
			return this.$store.state.CalendarStore.calendar_accomodation;
		},
		getExternalAccomodationCalendar: function () {
			return this.$store.state.CalendarStore.calendar_external_accomodation;
		},
		getConservationFeeCalendar: function () {
			return this.$store.state.CalendarStore.conservation_fees_calendar;
		},
		getVehicleFeeCalendar: function () {
			return this.$store.state.CalendarStore.vehicle_fees_calendar;
		},
		gatePasses: function () {
			return this.$store.state.BookingStore.gate_passes;
		},
		gatePass: function () {
			return this.$store.state.BookingStore.gate_pass;
		},
		confirmedBookings: function () {
			return this.$store.state.BookingStore.confirmed_bookings;
		},
		unconfirmedBookings: function () {
			return this.$store.state.BookingStore.un_confirmed_bookings;
		},
		checkedIn: function () {
			return this.$store.state.BookingStore.checked_in_bookings;
		},
		checkedOut: function () {
			return this.$store.state.BookingStore.checked_out_bookings;
		},
		gateDefaults: function () {
			return this.$store.state.BookingStore.gate;
		},
		getCurrentCalendar: function () {
			return this.$store.state.BookingStore.calendar;
		},
		destinations: function () {
			return this.$store.state.BookingStore.destinations;
		},
		approvedBookings: function () {
			return this.$store.state.BookingStore.approved;
		},
		bookingPaymentMethods: function () {
			return this.$store.state.PaymentMethodStore.all_payment_methods;
		},
		allBookingPaymentMethods: function () {
			return this.$store.state.PaymentMethodStore.all_payment_methods;
		},
		bookingPaymentGateways_: function () {
			return this.$store.state.PaymentMethodStore.payment_gateways;
		},

		allGates: function () {
			return this.$store.state.GateStore.all_gates;
		},
		allEntryModes: function () {
			return this.$store.state.GateStore.all_entry_modes;
    },
    unticketedVehicles: function () {
      //return this.$store.state.GateStore.unticketed_vehicles;
      return this.$store.state.BookingStore.inspection_unticketed_alerted_bookings;

    },
		partnerCheckinTodayBookings: function () {
			return this.$store.state.BookingStore.partner_checkin_today_bookings;
		},
		partnerCheckoutTodayBookings: function () {
			return this.$store.state.BookingStore.partner_checkout_today_bookings;
		},
		$bookingTickets: function () {
			return this.$store.state.BookingStore.booking_tickets;
		},
		$bookingPasses: function () {
			return this.$store.state.BookingStore.booking_passes;
		},
		batchFileData: function () {
			return this.$store.state.BookingStore.batchfile_data;
		},
		dailyReportData: function () {
			return this.$store.state.BookingStore.gate_entry_report.data;
		},
		dailyCSVReportData: function () {
			return this.$store.state.BookingStore.daily_report;
		},
		visitorsReportData: function () {
			return this.$store.state.VisitorStore.visitors_report;
		},
		csvdailyReportData: function () {
			return this.$store.state.BookingStore.gate_entry_report;
		},
		bookingsInspectionReportData: function () {
			return this.$store.state.BookingStore.bookings_inspection_report;
		},
		allSalesforceCredentials: function () {
			return this.$store.state.SalesForce.all_credentials;
		},
		allPaymentGateways: function () {
			return this.$store.state.PaymentMethodStore.payment_gateways;
		},
		gateEntryReport: function () {
			return this.$store.state.BookingStore.gate_entry_report;
		},
		dailyReport: function () {
			return this.$store.state.BookingStore.daily_report;
		},
		$paymentOptions: function () {
			return this.$store.state.PaymentMethodStore.payment_options;
		},
		$bookingsVolume: function () {
			return this.$store.state.BookingStore.volume;
		},
		$bookingsVolumeGtt: function () {
			return this.$store.state.BookingStore.volume_gtt;
		},
		$allSchools: function () {
			return this.$store.state.SchoolStore.all_schools;
		},
		$getBuyingRateBasedCreationDate: function () {

			var currencyToConvertTo = this.$store.state.CurrencyStore.browser_currency.toLowerCase();

			if (this.$route.name == 'BookingInspection') {
				if (this.singleInspectionBooking.currency) {
					var currencyToConvertFrom = this.singleInspectionBooking.currency.toLowerCase()

				}

			} else {
				if (this.singleBooking.currency) {

					var currencyToConvertFrom = this.singleBooking.currency.toLowerCase();
				}

			}

			if (currencyToConvertTo == "usd" && currencyToConvertFrom == 'kes') {
				let currency_to = "6bf74e49-7ff6-4555-a080-15541d62204a";

				let data = {
					currency_id: currency_to,
					date: this.$moment(this.singleBooking.created_at).format("YYYY-MM-DD")
				};
				this.$store.dispatch("get_currency_exchange_rate_by_date", data);
			}

		},
		totalOnlineDonations: function () {
			let payment_donations = this.$store.state.DonationStore.online_donation;
			var donationAmout = 0;
			if (payment_donations.length > 0) {
				for (let i = 0; i < payment_donations.length; i++) {
					let onlineDonation = payment_donations[i];
					if (onlineDonation.new_donation_currency === this.browserCurrencyID) {
						donationAmout =
							donationAmout + Math.ceil(onlineDonation.new_donation_amount);
					} else {
						if (
							this.browserCurrencyID ===
							"6bf74e49-7ff6-4555-a080-15541d62204a" &&
							onlineDonation.new_donation_currency ==
							"6bf74e49-7ff6-4555-a080-15541d62204a"
						) {
							// USD
							donationAmout =
								donationAmout + Math.ceil(onlineDonation.new_donation_amount);
						} else {
							donationAmout =
								donationAmout +
								this.convertBasedBookingCreationDate(
									onlineDonation.new_donation_currency_name,
									Math.ceil(onlineDonation.new_donation_amount),
									onlineDonation.new_donation_currency,
									onlineDonation.new_donation_currency_buy_rate,
									onlineDonation.new_donation_currency_sell_rate
								).amount;
						}
					}
				}

				return Math.ceil(donationAmout);
			} else {
				return Math.ceil(donationAmout)
			}
		},

		// for finance reporting
		$allPublicUserBookings: function () {
			return this.$store.state.BookingStore.puser_bookings;
		},
		$allBookingUserStatement: function () {
			return this.$store.state.BookingStore.finanace_statement;
		},
		$allBookingUsers: function () {
			return this.$store.state.BookingStore.booking_users
		},

		// payments summary
		$bankSlipData: function () {
			return this.$store.state.BookingStore.bankslip_data;
		},
		$bookingPaymentFailure: function () {
			return this.$store.state.BookingStore.booking_payment_failure;
		},
		$bookingPayments: function () {
			return this.$store.state.BookingStore.all_booking_payment;
		},
		

	}
};
